const API_BASE = (process.env.REACT_APP_API_BASE || "").replace(/\/$/, "");
const PENDING_PLAN_KEY = "frontplay_pending_plan";

/** Set true when Stripe paid plans are ready to sell. */
export const PAID_CHECKOUT_ENABLED = false;

export function setPendingPlan(plan) {
  try {
    if (plan === "light") {
      window.sessionStorage.setItem(PENDING_PLAN_KEY, plan);
    }
  } catch {
    /* ignore */
  }
}

export function takePendingPlan() {
  try {
    const plan = window.sessionStorage.getItem(PENDING_PLAN_KEY);
    window.sessionStorage.removeItem(PENDING_PLAN_KEY);
    return plan === "light" ? plan : null;
  } catch {
    return null;
  }
}

export async function startCheckout({ plan, accessToken, returnUrl }) {
  if (!PAID_CHECKOUT_ENABLED) throw new Error("Paid plans are coming soon");
  if (!API_BASE) throw new Error("API base is not configured");
  if (!accessToken) throw new Error("Login required");
  if (plan !== "light") throw new Error("Invalid plan");

  const res = await fetch(`${API_BASE}/api/billing/checkout`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${accessToken}`,
    },
    body: JSON.stringify({
      plan,
      returnUrl: returnUrl || window.location.origin,
    }),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.error || "Checkout failed");
  if (!data.url) throw new Error("Checkout URL missing");
  window.location.href = data.url;
}

export async function openBillingPortal({ accessToken, returnUrl }) {
  if (!API_BASE) throw new Error("API base is not configured");
  if (!accessToken) throw new Error("Login required");

  const res = await fetch(`${API_BASE}/api/billing/portal`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${accessToken}`,
    },
    body: JSON.stringify({
      returnUrl: returnUrl || window.location.origin,
    }),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.error || "Billing portal failed");
  if (!data.url) throw new Error("Portal URL missing");
  window.location.href = data.url;
}
